import {forEach} from 'ramda';
import bindEvent from '../../scripts/util/bindEvent';
import addClass from '../../scripts/util/DOM/addClass';
import qsa from '../../scripts/util/DOM/qsa';
import $ from 'jquery';
import {buidWithCurrentSlideIndex} from '../mac-slider/mac-slider';

const selectors = {
	tooltip: '.js-tooltip',
	body: '.tooltip__body',
	page: 'body',
	close: '.tooltip__close',
	content: '.tooltip__content'
};

const classes = {
	show: 'tooltip_show',
	right: 'tooltip_right',
	animate: 'tooltip_will_close'
};

const defaultWidth = '250';

const setPosition = (body, tooltip) => {
	const {left} = tooltip.getBoundingClientRect();
	const windowWidth = window.innerWidth;
	const right = window.innerWidth - (left + 25);

	if (windowWidth <= 768 && windowWidth > 420) {
		if (defaultWidth > left) {
			if (defaultWidth > right) {
				body.style.width = `${right - 10}px`;
			} else {
				body.style.width = `${defaultWidth}px`;
			}
			addClass(classes.right)(tooltip);
		}
	} else if (defaultWidth < left) {
		body.style.width = `${defaultWidth}px`;
	} else {
		body.style.width = `${left - 10}px`;
	}
};

const animate = tooltip => {
	addClass(classes.animate)(tooltip);
};

const removeAnimation = tooltip => () => {
	tooltip.classList.remove(classes.animate);
};

const toggleText = tooltip => {
	animate(tooltip);
	setTimeout(removeAnimation(tooltip), 100);
};

const removeClasses = tooltip => {
	tooltip.classList.remove(classes.right);
	tooltip.classList.remove(classes.show);

};

const close = tooltip => {
	const content = tooltip.querySelector(selectors.content);
	content.style.height = 0;
	content.style.width = 0;
};

const closeWithoutDelay = tooltip => {
	removeClasses(tooltip);
	close(tooltip);
	toggleText(tooltip);
};

const closeWithDelay = tooltip => {
	setTimeout(() => removeClasses(tooltip), 400);
	close(tooltip);
};

const closeAllTooltips = forEach(closeWithoutDelay);

const closeAllWithDelay = () => forEach(closeWithDelay, qsa(selectors.tooltip));

const closeAll = () => closeAllTooltips(qsa(selectors.tooltip));

const open = tooltip => {
	closeAll();
	const content = tooltip.querySelector(selectors.body);
	setPosition(content, tooltip);
	addClass(classes.show)(tooltip);
};

const getElemByEvent = e => {
	e.stopPropagation();
	const tooltip = e.currentTarget;
	const body = tooltip.querySelector(selectors.body);
	const isShow = tooltip.classList.contains(classes.show);

	return {tooltip, body, isShow};
};

const showMobile = props => {
	const {tooltip, body} = props;
	const $macSlider = $('#mac-slider');
	const {top} = $macSlider.offset();
	const height = $macSlider.height() + 55;
	const bodyStyle = body.style;
	const tooltipStyle = tooltip.style;

	open(tooltip);

	bodyStyle.height = `${height}px`;
	bodyStyle.width = `${window.innerWidth}px`;
	bodyStyle.right = `0`;

	tooltipStyle.top = `${top - 15}px`;
	tooltipStyle.right = `0`;
	tooltipStyle.left = ``;
};

const toggle = e => {
	const {tooltip, body, isShow} = getElemByEvent(e);
	const isMob = window.innerWidth <= 420;

	if (isShow) {
		closeWithoutDelay(tooltip);
		if (isMob) {
			buidWithCurrentSlideIndex();
		}
	} else if (isMob) {
		showMobile({tooltip, body});
	} else {
		open(tooltip, body);
	}
};

const render = () => {
	bindEvent(selectors.tooltip, 'click', toggle);
	bindEvent(selectors.close, 'click', closeAllWithDelay);
	bindEvent(selectors.page, 'click', closeAllWithDelay);
	bindEvent(selectors.page, 'keydown', closeAllWithDelay);
};

export default render;

